import * as React from "react";
import { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import usePermissions from "hooks/usePermissions";
import BootstrapModalConfirm from "components/bootstrap/BootstrapModalConfirm";
import { useRemoveEvidence } from "security-app/hooks/useInvestigationsAPI";
import LogsList from "./LogsList";
function Logs({ investigation }) {
  const { t } = useTranslation("enterprise_security_investigations");
  const { isPermitted } = usePermissions();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteLog, setDeleteLog] = useState(null);
  const canManageEvidence = useMemo(
    () => !investigation.archived && isPermitted("investigations:edit"),
    [investigation.archived, isPermitted]
  );
  const { removeEvidence, removingEvidence } = useRemoveEvidence();
  const removeLog = async () => {
    await removeEvidence({
      invId: investigation.id,
      payload: {
        logs: [{ id: deleteLog.id, index: deleteLog.index }]
      }
    });
    setShowDeleteDialog(false);
    setDeleteLog(null);
  };
  const onDelete = (log) => (e) => {
    e.stopPropagation();
    setShowDeleteDialog(true);
    setDeleteLog(log);
  };
  const onCancelDelete = () => {
    setShowDeleteDialog(false);
    setDeleteLog(null);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(LogsList, { investigation, canManageEvidence, onDelete })), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: showDeleteDialog,
      title: t("drawer_logs.delete_title"),
      onConfirm: removeLog,
      onCancel: onCancelDelete,
      confirmButtonDisabled: removingEvidence
    },
    t("drawer_logs.delete_confirm")
  ));
}
export default Logs;
